<template>
  <div>
    <div class="top">
      <i class="iconfont icon-back" @click="goback()"></i>
      <img src="/static/logo-64x64-blue.png">
    </div>

    <div v-if="haveData">
      <biaobai-item v-for="item in list" :key="item._id" :item="item"></biaobai-item>
    </div>
    <div class="empty" v-else>
      <img src="/static/none.png" style="width: 100%;">
    </div>

    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="isScrollBusy"
      infinite-scroll-distance="30"
    >
      <div align="center" style="margin-top: 10px; padding-bottom: 5px;">
        <cube-loading style="width: 24px;" v-if="isScrollBusy && !isScrollEnd"/>
        <span style="color: #999999; font-size: 0.8rem;" v-else-if="isScrollEnd && haveData">没有更多了</span>
      </div>
    </div>
  </div>
</template>

<script>
import BiaobaiItem from "../common/BiaobaiItem";
import weui from "weui.js";
import axios from "axios";

export default {
  components: {
    BiaobaiItem
  },
  data() {
    return {
      encodeToken: "",
      token: "",
      openid: null,
      list: [],
      haveData: true,
      isScrollBusy: false,
      isScrollEnd: false,
      pageNo: 0,
      pageCount: 0
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    if (!this.$store.state.User.userInfo._id) {
      axios
        .get("/api/user/wxuserInfo")
        .then(res => {
          if (res.data.success) {
            this.openid = res.data.data.openid;
            this.$store.commit("User/add", res.data.data);
          } else {
            weui.alert("获取用户信息失败");
          }
        })
        .catch(err => {
          weui.alert("获取用户信息失败");
        });
    } else {
      this.openid = this.$store.state.User.userInfo.openid;
    }
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },
    loadMore() {
      if (this.isScrollEnd || this.isScrollBusy) {
        return;
      }
      console.log("loadMore");
      this.isScrollBusy = true;
      this.pageNo = this.pageNo + 1;
      let params = {
        pageNo: this.pageNo
      };
      setTimeout(() => {
        axios
          .get("/api/circle/sfPaging", { params })
          .then(res => {
            this.isScrollBusy = false;
            if (res.data.success) {
              this.pageCount = res.data.data.pageCount;
              if (this.pageCount > 0) {
                this.haveData = true;
              } else {
                this.haveData = false;
              }

              if (res.data.data.pageNumber >= this.pageCount) {
                this.isScrollEnd = true;
              } else {
                this.isScrollEnd = false;
              }

              this.list = this.list.concat(res.data.data.results);
            } else {
              weui.topTips("获取圈子列表出错", 1500);
            }
          })
          .catch(err => {
            this.isScrollBusy = false;
            console.log(err);
            weui.topTips("获取圈子列表出错", 1500);
          });
      }, 500);
    }
  }
};
</script>

<style scoped>
.top {
  margin-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #1296db;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.top i {
  position: absolute;
  left: 10px;
  font-size: 22px;
  color: #1296db;
}
.top img {
  height: 26px;
}
.empty {
  padding: 50px;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/CircleShareList.vue